<template>
    <div>
        <bc-circle-loader v-if="loading == true"></bc-circle-loader>
        <v-container v-else fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ rfq.rfq_id ? $t("lang.edit_rfq_request") : $t("lang.add_rfq_request") }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="rfq.rfq_id && rfq.rfq_id > 0" @invoke-method="dbGetRfq(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="rfq.rfq_id && rfq.rfq_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title>{{ $t("lang.print_rfq") }}</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="current_user.login_type_id == '1'" @click="setEmailDialog()">
                                    <v-list-tile-title>{{ $t("lang.email_rfq") }}</v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('rfqs.update') && rfq.status_id != 31 && rfq.status_id != 165 && current_user.login_type_id == '1'">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="convertToPurchaseOrder()">
                                        <v-list-tile-title>{{ $t("lang.convert_to_purchase_order") }}</v-list-tile-title>
                                    </v-list-tile>
                                </template>
                                <template v-if="hasPerm('rfqs.update') && rfq.status_id != 31 && rfq.status_id != 30 && rfq.status_id != 165">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="changeStatus('30')">
                                        <v-list-tile-title>
                                            {{ $t(`lang.reject_quote`) ? $t(`lang.reject_quote`) : `Reject Quote` }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                                <template v-if="hasPerm('rfqs.delete') && rfq.status_id != 165">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_rfq.openDialog()">
                                        <v-list-tile-title>{{ $t("lang.delete") }}</v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'rfqs' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-container fluid grid-list-xl :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <bc-transaction-links :items="rfq.transaction_links" :object_id="rfq.rfq_id"></bc-transaction-links>
                    <v-flex :class="rfq.rfq_id != null ? 'lg10 md9 xs12' : 'lg12 md12 xs12'" pb-0 mb-0>
                        <v-card elevation="0">
                            <v-card-text :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                                <div v-if="rfq.status" class="ribbon ribbon-top-right" :class="`ribbon-${rfq.status_class}`">
                                    <span class="ribbon-span">{{ rfq.status }}</span>
                                </div>

                                <vue-perfect-scrollbar
                                    class="scroll-area"
                                    :style="$bp.xs ? null : 'max-height: calc(100vh - 260px); min-height: calc(100vh - 260px)'"
                                >
                                    <v-form ref="formRfq">
                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                            <v-flex xs12 sm6 row-2-fr1>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12>
                                                        <bc-autocomplete
                                                            v-model="rfq.vendor_id"
                                                            v-if="rfq.rfq_id == null && rfq.rfq_details.length <= 0"
                                                            :label="`${$t('lang.vendor')} *`"
                                                            :items="vendor_options"
                                                            item-value="company_id"
                                                            item-text="company"
                                                            :rules="ifValid('rfqs.vendor_id')"
                                                            @change="selectVendor(rfq.vendor_id)"
                                                        ></bc-autocomplete>
                                                        <v-text-field
                                                            v-else
                                                            :value="rfq.vendor ? rfq.vendor : vendor_options.find((x) => x.company_id == rfq.vendor_id).company"
                                                            :label="$t('lang.vendor')"
                                                            disabled
                                                            append-icon="lock"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 v-if="rfq.vendor_id != null">
                                                        <bc-autocomplete
                                                            v-if="rfq.status_id != 165 && current_user.login_type_id == '1'"
                                                            v-model="rfq.company_id"
                                                            :label="`${$t('lang.customer')} *`"
                                                            :items="filter_customer_options"
                                                            item-value="company_id"
                                                            item-text="company"
                                                            :rules="ifValid('rfqs.company_id')"
                                                            @change="selectCustomer(rfq.company_id)"
                                                        ></bc-autocomplete>
                                                        <v-text-field
                                                            v-else
                                                            v-model="rfq.company"
                                                            :placeholder="$t('lang.company')"
                                                            :disabled="current_user.slug == 'vendor'"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 v-else>
                                                        <bc-tooltip top>
                                                            <template slot="activator">
                                                                <bc-autocomplete
                                                                    v-model="rfq.company_id"
                                                                    :label="`${$t('lang.customer')} *`"
                                                                    item-value="company_id"
                                                                    item-text="company"
                                                                    :rules="ifValid('rfqs.company_id')"
                                                                    :disabled="true"
                                                                    append-icon="lock"
                                                                ></bc-autocomplete>
                                                            </template>
                                                            You must select a vendor before selecting a customer.
                                                        </bc-tooltip>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <div class="customer-address" style="padding: 12px">
                                                            <h3>
                                                                {{ $t("lang.billing_address_id") }}
                                                                <!-- <v-btn
                                                                    color="secondary"
                                                                    icon
                                                                    small
                                                                    @mouseup.left="changeAddress('bill_address')"
                                                                    v-if="rfq.status_id != 31 && rfq.status_id != 30"
                                                                >
                                                                    <v-icon small>edit</v-icon>
                                                                </v-btn> -->
                                                            </h3>
                                                            <div>
                                                                <div>{{ $t("lang.org_bill_location_label") }}</div>
                                                                <div>{{ $t("lang.org_bill_address1") }}</div>
                                                                <div v-if="$t('lang.org_bill_address2') != ''">
                                                                    {{ $t("lang.org_bill_address1") }}
                                                                </div>
                                                                <div>
                                                                    {{ $t("lang.org_bill_city") }}, {{ $t("lang.org_bill_state") }},
                                                                    {{ $t("lang.org_bill_zip_code") }}
                                                                </div>
                                                                <div>{{ $t("lang.org_bill_country_iso_3") }}</div>
                                                            </div>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <div class="customer-address" v-if="rfq.shipping_address_id != null" style="padding: 12px">
                                                            <h3>
                                                                {{ $t("lang.shipping_address_id") }}
                                                                <v-btn
                                                                    color="secondary"
                                                                    icon
                                                                    small
                                                                    @mouseup.left="changeAddress('ship_address')"
                                                                    v-if="
                                                                        rfq.status_id != 31 &&
                                                                        rfq.status_id != 30 &&
                                                                        rfq.status_id != 165 &&
                                                                        current_user.login_type_id == '1'
                                                                    "
                                                                >
                                                                    <v-icon small>edit</v-icon>
                                                                </v-btn>
                                                            </h3>
                                                            <div>
                                                                <div v-if="rfq.ship_location_label">{{ rfq.ship_location_label }}</div>
                                                                <div>{{ rfq.ship_address1 }}</div>
                                                                <div v-if="rfq.ship_address2 != ''">
                                                                    {{ rfq.ship_address2 }}
                                                                </div>
                                                                <div>
                                                                    {{ rfq.ship_city }}, {{ rfq.ship_state }},
                                                                    {{ rfq.ship_zip_code }}
                                                                </div>
                                                                <div>{{ rfq.ship_country_iso_3 }}</div>
                                                            </div>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm6>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        v-if="rfq.rfq_id"
                                                        v-model="rfq.rfq_id"
                                                        :label="$t('lang.rfq_id')"
                                                        :counter="showCounter(rfq.rfq_id, 'rfqs.rfq_id')"
                                                        :rules="ifValid('rfqs.rfq_id')"
                                                        :disabled="current_user.login_type_id != '1' ? true : false"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-date-picker
                                                            v-model="rfq.rfq_date"
                                                            :label="`${$t('lang.rfq_date')} *`"
                                                            :rules="ifValid('rfqs.rfq_date')"
                                                            :is_disabled="current_user.login_type_id != '1' ? true : false"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-text-field
                                                            v-model="rfq.reference_number"
                                                            :label="$t('lang.vendor_reference_number')"
                                                            :counter="showCounter(rfq.reference_number, 'rfqs.reference_number')"
                                                            :rules="ifValid('rfqs.reference_number')"
                                                            :disabled="rfq.status_id == '31' || rfq.status_id == '165' || rfq.status_id == '30' ? true : false"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-if="current_user.login_type_id == '1'"
                                                            v-model="rfq.shipping_carrier_id"
                                                            :label="$t('lang.shipping_carrier_id')"
                                                            :items="filter_shipping_carriers"
                                                            item-value="company_id"
                                                            item-text="company"
                                                            :rules="ifValid('rfqs.shipping_carrier_id')"
                                                        ></bc-autocomplete>
                                                        <v-text-field
                                                            v-else
                                                            v-model="rfq.shipping_carrier"
                                                            :placeholder="$t('lang.shipping_carrier_id')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-if="current_user.login_type_id == '1'"
                                                            v-model="rfq.freight_term_id"
                                                            :label="$t('lang.freight_term_id')"
                                                            :items="filter_freight_terms"
                                                            item-value="option_id"
                                                            item-text="option"
                                                            :rules="ifValid('rfqs.freight_term_id')"
                                                        ></bc-autocomplete>
                                                        <v-text-field
                                                            v-else
                                                            v-model="rfq.freight_term"
                                                            :placeholder="$t('lang.freight_term_id')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-model="rfq.currency_id"
                                                            :label="$t('lang.document_currency')"
                                                            :items="filter_currencies"
                                                            item-value="currency_id"
                                                            item-text="name"
                                                            :rules="ifValid('rfqs.currency_id')"
                                                            @change="setExchangeRate(rfq.currency_id)"
                                                            :append-icon="current_user.login_type_id != '1' ? 'lock' : 'arrow_drop_down'"
                                                            :disabled="current_user.login_type_id != '1' ? true : false"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-text-field
                                                            v-model="rfq.exchange_rate"
                                                            :label="$t('lang.exchange_rate')"
                                                            :counter="showCounter(rfq.exchange_rate, 'rfqs.exchange_rate')"
                                                            :rules="ifValid('rfqs.exchange_rate')"
                                                            :disabled="current_user.login_type_id != '1' ? true : false"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-flex xs12 v-if="current_user.login_type_id == '1'">
                                                    <bc-autocomplete
                                                        v-model="rfq.project_id"
                                                        :label="`${$t('lang.project')}`"
                                                        :items="projects"
                                                        item-value="project_id"
                                                        item-text="project_name"
                                                        :rules="ifValid('rfqs.project_id')"
                                                    ></bc-autocomplete>
                                                </v-flex>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs6>
                                                        <bc-date-picker
                                                            v-model="rfq.required_by_date"
                                                            :label="`${$t('lang.required_by_date')} *`"
                                                            :rules="ifValid('rfqs.required_by_date')"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        <bc-date-picker
                                                            v-model="rfq.expiration_date"
                                                            :label="`${$t('lang.expiration_date')} *`"
                                                            :rules="ifValid('rfqs.expiration_date')"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>

                                        <div>
                                            <v-data-table
                                                :headers="rfq_headers"
                                                :items="rfq.rfq_details || []"
                                                item-key="rfq_detail_id"
                                                no-data-text="There are 0 parts on this RFQ"
                                                hide-actions
                                                class="custom-table"
                                            >
                                                <template slot="items" slot-scope="props">
                                                    <tr>
                                                        <td>
                                                            <bc-autocomplete
                                                                v-if="props.item.part_id == null"
                                                                v-model="props.item.map_id"
                                                                :items="fe_part_options_by_vendor || []"
                                                                item-value="vendor_map_id"
                                                                item-text="vendor_sku"
                                                                @change="handleChangePart(props.index, props.item)"
                                                                :rules="ifValid('rfqs.rfq_details.map_id')"
                                                                :filter="$filterFeParts"
                                                                hide-details
                                                                :ref="`${props.index}_map_id`"
                                                                :append-icon="current_user.login_type_id != '1' ? 'lock' : 'arrow_drop_down'"
                                                                :disabled="current_user.login_type_id != '1' ? true : false"
                                                            >
                                                                <template slot="item" slot-scope="data">
                                                                    <v-list-tile-content>
                                                                        <v-list-tile-title
                                                                            ><strong>{{ data.item.vendor_sku }}</strong></v-list-tile-title
                                                                        >
                                                                        <v-list-tile-sub-title>{{ `Name: ${data.item.name}` }}</v-list-tile-sub-title>
                                                                        <v-list-tile-sub-title>{{ `Model: ${data.item.model_number}` }}</v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </template>
                                                            </bc-autocomplete>
                                                            <v-list-tile v-else class="full-height-tile">
                                                                <v-list-tile-content>
                                                                    <v-list-tile-title
                                                                        ><strong>{{ props.item.vendor_sku || props.item.sku }}</strong></v-list-tile-title
                                                                    >
                                                                    <v-list-tile-sub-title>{{ `Name: ${props.item.name}` }}</v-list-tile-sub-title>
                                                                    <v-list-tile-sub-title>{{ `Model: ${props.item.model_number}` }}</v-list-tile-sub-title>
                                                                    <v-textarea
                                                                        class="custom-textarea"
                                                                        outline
                                                                        v-model="props.item.line_description"
                                                                        placeholder="Add a description to your item"
                                                                        hide-details
                                                                        style="width: 100%"
                                                                        :rules="ifValid('rfqs.rfq_details.line_description')"
                                                                        auto-grow
                                                                        rows="1"
                                                                        :disabled="current_user.login_type_id == '1' ? false : true"
                                                                    ></v-textarea>
                                                                </v-list-tile-content>
                                                                <v-list-tile-action
                                                                    v-if="current_user.login_type_id == '1'"
                                                                    style="position: absolute; top: 0px; right: 0px; align-items: normal"
                                                                >
                                                                    <v-btn icon ripple @click="resetLine(props.index, props.item)">
                                                                        <v-icon color="grey lighten-1">cancel</v-icon>
                                                                    </v-btn>
                                                                </v-list-tile-action>
                                                            </v-list-tile>
                                                            <!-- <small v-if="props.item.map_id" class="fs-12">{{ props.item.name }}</small>
                                                            <br />
                                                            <small v-if="props.item.map_id" class="fs-12">{{ props.item.model_number }}</small> -->
                                                        </td>
                                                        <td>
                                                            {{ props.item.mfg_name }}
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                v-model="props.item.hts_code"
                                                                :disabled="current_user.login_type_id != '1' ? true : false"
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                v-model="props.item.lead_time"
                                                                :rules="ifValid('rfqs.rfq_details.lead_time')"
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                v-model="props.item.quantity"
                                                                :ref="`${props.index}_quantity`"
                                                                :rules="ifValid('rfqs.rfq_details.quantity')"
                                                                :disabled="current_user.login_type_id != '1' ? true : false"
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                prefix="$"
                                                                v-model="props.item.cost_price"
                                                                :rules="ifValid('rfqs.rfq_details.cost_price')"
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <bc-autocomplete
                                                                v-if="current_user.login_type_id == '1'"
                                                                v-model="props.item.sales_unit"
                                                                :items="filter_sales_units(props.item)"
                                                                item-value="option_id"
                                                                item-text="option"
                                                                :rules="ifValid('rfqs.rfq_details.sales_unit')"
                                                            ></bc-autocomplete>
                                                            <bc-autocomplete
                                                                v-else
                                                                v-model="props.item.sales_unit"
                                                                :items="filter_sales_units(props.item)"
                                                                item-value="option_id"
                                                                item-text="option"
                                                                :rules="ifValid('rfqs.rfq_details.sales_unit')"
                                                                disabled
                                                                append-icon="lock"
                                                            ></bc-autocomplete>
                                                        </td>
                                                        <td v-if="rfq.status_id != 165">
                                                            <v-icon
                                                                @click="removeRow(props.index)"
                                                                v-if="rfq.status_id != 31 && rfq.status_id != 30 && current_user.login_type_id == '1'"
                                                                >delete</v-icon
                                                            >
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                            <div
                                                class="text-center"
                                                v-if="rfq.status_id != 31 && rfq.status_id != 30 && rfq.status_id != 165 && current_user.login_type_id == '1'"
                                            >
                                                <v-btn v-if="rfq.vendor_id != null" tile color="primary" @click="addRow()">{{ $t("lang.add_more") }}</v-btn>
                                            </div>
                                        </div>
                                        <v-flex xs12>
                                            <v-textarea
                                                v-model="rfq.comments"
                                                :label="$t('lang.comments')"
                                                auto-grow
                                                rows="1"
                                                :rules="ifValid('rfqs.comments')"
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <bc-autocomplete
                                                v-model="rfq.department_id"
                                                :label="$t('lang.department')"
                                                :items="department_options"
                                                item-value="department_id"
                                                item-text="department_name"
                                                :rules="ifValid('rfqs.department_id')"
                                                :append-icon="current_user.login_type_id != '1' ? 'lock' : 'arrow_drop_down'"
                                                :disabled="current_user.login_type_id != '1' ? true : false"
                                            ></bc-autocomplete>
                                        </v-flex>
                                    </v-form>
                                </vue-perfect-scrollbar>
                            </v-card-text>
                            <v-card-actions v-if="rfq.status_id != 31 && rfq.status_id != 30 && rfq.status_id != 165">
                                <v-spacer></v-spacer>
                                <v-btn @mouseup.left="$router.push({ name: 'rfqs' })" flat>{{ $t("lang.cancel") }}</v-btn>
                                <v-btn color="success" @click="saveRfqs">{{ $t("lang.save") }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

            <bc-modal-email ref="emailDialog" :pdfReportName="`rfq_${rfq.rfq_id}.pdf`" :endPoint="`/rfqs/${rfq.rfq_id}/email`"></bc-modal-email>

            <bc-address-selector ref="select_address_dialog" @eventname="updateAddress"></bc-address-selector>
            <delete-confirmation-dialog
                ref="delete_rfq"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_rfq')"
                :message="$t('lang.delete_rfq_confirm')"
                @onConfirm="deleteRfqs()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_rfq_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteRfqDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import axios from "axios";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],
            rfq_headers: [
                { text: this.$t("lang.part_id"), sortable: false, width: "20%" },
                { text: this.$t("lang.manufacturer"), sortable: false, width: "15%" },
                { text: this.$t("lang.hts_code"), sortable: false, width: "10%" },
                { text: this.$t("lang.lead_time"), sortable: false, width: "10%" },
                { text: this.$t("lang.quantity"), sortable: false, width: "5%" },
                { text: this.$t("lang.cost_price"), sortable: false, width: "15%" },
                { text: this.$t("lang.sales_unit"), sortable: false, width: "20%" },
                { text: "", width: "3%", sortable: false },
            ],
            formData: {},
            rfq: {
                rfq_details: [],
                billing_address_id: null,
                shipping_address_id: null,
                bill_address: null,
                ship_address: null,
                address_options: [],
                currency_id: "1",
                exchange_rate: "1.000000",
                vendor_id: null,
            },
            company: {},
            file_name: "",
            dbGetRfq: _.debounce(this.getRfq, 1500, { maxWait: 1500, leading: true, trailing: false }),
            email_dialog: false,
            loading: true,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchRfq", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.rfq) {
                        this.rfq = this.assignObj2(data.rfq, this.rules_rfqs);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=rfq_status&sort_by=2",
                            method: "get",
                            stateProperty: "rfq_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        this.refresh();
                        next();
                    } else {
                        next({ name: "rfqs", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchRfq", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.rfq) {
                        next((vm) => {
                            vm.rfq = vm.assignObj2(data.rfq, vm.rules_rfqs);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=rfq_status&sort_by=2",
                                method: "get",
                                stateProperty: "rfq_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.$store.commit("toggleMainMenu", false);
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "rfqs", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetOptions");
        this.$store.commit("resetPeople");
        this.$store.commit("resetCustomers");
        this.$store.commit("resetCurrencies");
        this.$store.commit("resetFeParts");
        this.$store.commit("resetPaymentTerms");
        this.$store.commit("resetDepartments");
        this.$store.commit("resetShippingCarriers");
        this.$store.commit("resetProjects");
        next();
    },
    computed: {
        ...mapState({
            rules_rfqs: (state) => state.rfqs.rules_rfqs,
            rfq_status_options: (state) => state.settings.rfq_status_options,
            rfqs: (state) => state.rfqs.rfqs,
            selectedRfq: (state) => state.rfqs.selectedRfq,
            fe_part_options_by_vendor: (state) => state.fe_parts.fe_part_options_by_vendor,
            shipping_carriers: (state) => state.shipping_carriers.shipping_carrier_options,
            department_options: (state) => state.departments.department_options,
            customer_options: (state) => state.customers.customer_options,
            vendor_options: (state) => state.vendors.vendor_options,
            freight_terms: (state) => state.options_categories.freight_terms,
            rfq_status: (state) => state.options_categories.rfq_status,
            sales_units: (state) => state.options_categories.sales_units,
            currencies: (state) => state.currencies.currencies,
            projects: (state) => state.projects.project_options,
        }),
        filter_customer_options() {
            return this.customer_options.filter((record) => !record.date_deleted || record.company_id === this.rfq.company_id);
        },
        filter_freight_terms() {
            return this.freight_terms.filter((record) => !record.date_deleted || record.option_id === this.rfq.freight_term_id);
        },
        filter_shipping_carriers() {
            return this.shipping_carriers.filter((record) => !record.date_deleted || record.company_id === this.rfq.shipping_carrier_id);
        },
        filter_currencies() {
            return this.currencies.filter((record) => !record.date_deleted || record.currency_id === this.rfq.currency_id);
        },
        filter_fe_part_options_by_vendor: function () {
            return function (item) {
                return this.fe_part_options_by_vendor.filter((record) => record.vendor_id === this.rfq.vendor_id);
            };
        },
        filter_sales_units: function () {
            return function (item) {
                return this.sales_units.filter((record) => !record.date_deleted || record.option_id === item.sales_unit);
            };
        },
    },
    methods: {
        ...mapActions([
            "fetchRfq",
            "saveRfq",
            "deleteRfq",
            "printRfq",
            "fetchFeParts",
            "convertRfqToQuote",
            "convertRFQToPurchaseOrder",
            "fetchCurrencies",
            "fetchShippingCarriers",
            "fetchCustomers",
            "fetchDepartments",
            "fetchOptions",
            "fetchVendors",
            "fetchProjects",
            "fetchFePart",
            "fetchVendor",
            "fetchCustomer",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        addRow() {
            if (!this.rfq.rfq_details) this.rfq.rfq_details = [];
            this.rfq.rfq_details.push({
                rfq_id: `${this.$route.params.id}`,
                quantity: "",
                sales_unit: "",
                model_number: "",
                name: "",
                mfg_name: "",
                hts_code: "",
            });
        },
        removeRow: function (index) {
            this.rfq.rfq_details.splice(index, 1);
        },
        changeAddress(type) {
            let address_list = this.rfq.address_options ? this.rfq.address_options : this.company.entity_addresses || [];
            this.$refs.select_address_dialog.showAddresses(address_list, type);
        },
        updateAddress(item, type) {
            if (type == "bill_address") {
                this.rfq.billing_address_id = item.entity_addresses_id;
                this.rfq.bill_location_label = item.location_label;
                this.rfq.bill_address1 = item.address1;
                this.rfq.bill_address2 = item.address2;
                this.rfq.bill_city = item.city;
                this.rfq.bill_state = item.state;
                this.rfq.bill_zip_code = item.zip_code;
                this.rfq.bill_zip_code_ext = item.zip_code_ext;
                this.rfq.bill_country_iso_3 = item.country_iso_3;
            } else if (type == "ship_address") {
                this.rfq.shipping_address_id = item.entity_addresses_id;
                this.rfq.ship_location_label = item.location_label;
                this.rfq.ship_address1 = item.address1;
                this.rfq.ship_address2 = item.address2;
                this.rfq.ship_city = item.city;
                this.rfq.ship_state = item.state;
                this.rfq.ship_zip_code = item.zip_code;
                this.rfq.ship_zip_code_ext = item.zip_code_ext;
                this.rfq.ship_country_iso_3 = item.country_iso_3;
            }
        },
        getRfq(pg_refresh = false) {
            this.startLoader();

            this.fetchRfq({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.rfq) {
                    this.rfq = this.assignObj2(data.rfq, this.rules_rfqs);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        emailRfq() {},
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printRfq({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.rfq) {
                    if (this.dev_mode) {
                        this.file_name = data.rfq.file_name;
                    } else {
                        this.$refs.print.printReport(data.rfq.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveRfqs() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formRfq")) {
                    let body = this.prepForm(this.rfq, this.rules_rfqs);

                    this.saveRfq({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.rfq) {
                            this.$router.push({ name: "rfq", params: { id: data.rfq.rfq_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(status_id) {
            this.status_loader = true;
            let body = { rfq_id: `${this.$route.params.id}`, status_id: status_id };

            this.saveRfq({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.rfq) {
                    this.rfq = this.assignObj2(data.rfq, this.rules_rfqs);
                }
            });
        },
        deleteRfqs() {
            this.deleteRfq({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.$refs.delete_rfq_details.close();
                    this.validationOff();
                    this.$router.push({ name: "rfqs" });
                }
                this.toggleModalLoader(false);
            });
        },
        convertToQuote() {
            this.status_loader = true;
            let body = { rfq_id: `${this.$route.params.id}` };

            this.convertRfqToQuote({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.quote) {
                    this.$router.push({ name: "quote", params: { id: data.quote.quote_id } });
                }
            });
        },
        convertToPurchaseOrder() {
            this.status_loader = true;
            let body = { rfq_id: `${this.$route.params.id}` };

            this.convertRFQToPurchaseOrder({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.purchase_order) {
                    this.$router.push({
                        name: "purchase_order",
                        params: { id: data.purchase_order.purchase_order_id },
                    });
                }
            });
        },
        selectVendor(company_id) {
            if (company_id == null) {
                return;
            } else {
                this.fetchVendor({ id: company_id }).then((data) => {
                    if (data.vendor) {
                        this.company = data.vendor;
                        this.rfq.currency_id = this.company.currency_id ? this.company.currency_id : "1";
                        this.rfq.exchange_rate = this.company.exchange_rate ? this.company.exchange_rate : "1.000000";
                        this.rfq.payment_term_id = this.company.payment_term_id;

                        if (this.rfq.vendor_id != null)
                            this.fetchFeParts({
                                body: {
                                    options: 1,
                                    by_vendor: 1,
                                    vendor_id: this.rfq.vendor_id,
                                    with_trashed: this.rfq.rfq_id ? "1" : "0",
                                },
                            });
                    }
                });
            }
        },
        selectCustomer(company_id) {
            let company = null;
            if (company_id == null) {
                return;
            } else {
                this.fetchCustomer({ id: company_id }).then((data) => {
                    if (data.customer) {
                        company = data.customer;

                        this.rfq.address_options = company.entity_addresses ? company.entity_addresses : [];

                        let ship_address = company.entity_addresses ? company.entity_addresses.filter((x) => x.address_type == "shipping")[0] : null;
                        this.rfq.shipping_address_id = ship_address && ship_address.entity_addresses_id ? ship_address.entity_addresses_id : null;
                        this.rfq.ship_location_label = ship_address && ship_address.location_label ? ship_address.location_label : null;
                        this.rfq.ship_address1 = ship_address && ship_address.address1 ? ship_address.address1 : null;
                        this.rfq.ship_address2 = ship_address && ship_address.address2 ? ship_address.address2 : null;
                        this.rfq.ship_city = ship_address && ship_address.city ? ship_address.city : null;
                        this.rfq.ship_state = ship_address && ship_address.state ? ship_address.state : null;
                        this.rfq.ship_zip_code = ship_address && ship_address.zip_code ? ship_address.zip_code : null;
                        this.rfq.ship_zip_code_ext = ship_address && ship_address.zip_code_ext ? ship_address.zip_code_ext : null;
                        this.rfq.ship_country_iso_3 = ship_address && ship_address.country_iso_3 ? ship_address.country_iso_3 : null;

                        this.rfq.bill_location_label = "DOWA THT AMERICA, INC.";
                        this.rfq.bill_address1 = "2130 S. Woodland Cir";
                        this.rfq.bill_address2 = null;
                        this.rfq.bill_city = "Bowling Green";
                        this.rfq.bill_state = "Ohio";
                        this.rfq.bill_zip_code = "43402";
                        this.rfq.bill_zip_code_ext = null;
                        this.rfq.bill_country_iso_3 = "USA";
                    }
                });
            }
        },
        handleChangePart(index, item) {
            // Get the part from the parts array based on the part_id
            let partObj = this.fe_part_options_by_vendor.find((x) => x.vendor_map_id == item.map_id);
            this.fetchFePart({ id: partObj.part_id }).then((data) => {
                if (typeof data !== "undefined" && data.fe_part) {
                    partObj = data.fe_part;
                    this.rfq.rfq_details[index].part_id = partObj.part_id;
                    this.rfq.rfq_details[index].model_number = partObj.model_number;
                    this.rfq.rfq_details[index].sales_unit = partObj.sales_unit;
                    this.rfq.rfq_details[index].name = partObj.name;
                    this.rfq.rfq_details[index].lead_time = partObj.lead_time;
                    this.rfq.rfq_details[index].mfg_name = partObj.mfg_name;
                    this.rfq.rfq_details[index].hts_code = partObj.hts_code;
                    this.rfq.rfq_details[index].vendor_sku = partObj.preferred_vendor_sku;

                    this.$refs[`${index}_quantity`].$el.querySelector("input").focus();
                }
            });
        },
        resetLine(index, item) {
            this.rfq.rfq_details[index].part_id = null;
            this.rfq.rfq_details[index].model_number = null;
            this.rfq.rfq_details[index].sales_unit = null;
            this.rfq.rfq_details[index].name = null;
            this.rfq.rfq_details[index].lead_time = null;
            this.rfq.rfq_details[index].hts_code = null;
            this.rfq.rfq_details[index].line_description = null;
            this.rfq.rfq_details[index].map_id = null;
            this.rfq.rfq_details[index].mfg_name = null;

            this.$nextTick(() => {
                this.$refs[`${index}_map_id`].$children[0].focus();
                this.$refs[`${index}_map_id`].$children[0].isMenuActive = true;
            });
        },
        setExchangeRate(currency_id) {
            let exchange_rate = this.currencies.find((x) => x.currency_id == currency_id);
            this.rfq.currency_id = currency_id;
            this.rfq.exchange_rate = exchange_rate.exchange_rate ? exchange_rate.exchange_rate : "1.000000";
        },
        setEmailDialog() {
            this.validationOff();
            this.$refs.emailDialog.showEmail();
        },
        refresh(force = false) {
            this.startLoader();
            if (this.current_user.login_type_id == "1") {
                if (this.customer_options.length == 0 || force == true)
                    this.fetchCustomers({ body: { options: 1, with_trashed: this.rfq.rfq_id ? "1" : "0" } });
                if (this.vendor_options.length == 0 || force == true) this.fetchVendors({ body: { options: 1, with_trashed: this.rfq.rfq_id ? "1" : "0" } });
                if (this.freight_terms == 0 || force == true)
                    this.fetchOptions({ body: { slug: "freight_terms", with_trashed: this.rfq.rfq_id ? "1" : "0", options: 1 } });
                if (this.shipping_carriers.length == 0 || force == true)
                    this.fetchShippingCarriers({ body: { options: 1, with_trashed: this.rfq.rfq_id ? "1" : "0", department_id: "1" } });
            }

            if (this.currencies.length == 0 || force == true) this.fetchCurrencies({ body: { options: 1, with_trashed: this.rfq.rfq_id ? "1" : "0" } });

            if (this.rfq.vendor_id != null || force == true)
                this.fetchFeParts({
                    body: { options: 1, by_vendor: 1, vendor_id: this.rfq.vendor_id, with_trashed: this.rfq.rfq_id ? "1" : "0" },
                });

            if (this.rfq_status == 0 || force == true)
                this.fetchOptions({ body: { slug: "rfq_status", with_trashed: this.rfq.rfq_id ? "1" : "0", options: 1 } });

            if (this.sales_units == 0 || force == true)
                this.fetchOptions({ body: { slug: "sales_units", sort_by: "0", with_trashed: this.rfq.rfq_id ? "1" : "0", options: 1 } });

            if (this.department_options.length == 0 || force == true)
                this.fetchDepartments({ body: { options: 1, with_trashed: this.rfq.rfq_id ? "1" : "0" } });

            if (!this.rfq.department_id) this.rfq.department_id = this.currUserField("department_id");
            if (this.rfq.rfq_date == null || force == true) this.rfq.rfq_date = new Date().toISOString().slice(0, 10);

            if (this.rfq.status_id == 165) {
                this.rfq_headers.pop();
            } else {
                this.rfq_headers = [
                    { text: this.$t("lang.part_id"), sortable: false, width: "20%" },
                    { text: this.$t("lang.part"), sortable: false, width: "15%" },
                    { text: this.$t("lang.hts_code"), sortable: false, width: "10%" },
                    { text: this.$t("lang.lead_time"), sortable: false, width: "10%" },
                    { text: this.$t("lang.quantity"), sortable: false, width: "5%" },
                    { text: this.$t("lang.cost_price"), sortable: false, width: "15%" },
                    { text: this.$t("lang.sales_unit"), sortable: false, width: "20%" },
                    { text: "", width: "3%", sortable: false },
                ];
            }

            if (force == true) {
                this.fetchRfq({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.rfq) {
                        this.rfq = this.assignObj2(data.rfq, this.rules_rfqs);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            }

            if (this.projects.length == 0 || force == true) this.fetchProjects({ body: { options: 1 } });

            this.loading = false;
            this.finishLoader();
        },
    },
    mounted() {
        this.refresh();
    },
};
</script>
<style lang="css">
.ui-col-2 {
    display: flex;
    flex-wrap: wrap;
}

.column {
    flex: 1;
    padding: 10px;
    box-sizing: border-box;
}

.left-column {
    order: 1;
}

.right-column {
    order: 2;
}

.overlay {
    opacity: 0.25;
    pointer-events: none;
}

.custom-table .v-table tbody tr td {
    vertical-align: top !important;
}

.full-height-tile .v-list__tile {
    height: 100%;
}

.custom-textarea textarea {
    padding-right: 0px !important;
    font-size: 14px;
    margin-top: 0px !important;
    padding: 4px !important;
}

.custom-textarea .v-input__slot {
    padding: 0px !important;
    border: 1px solid rgba(0, 0, 0, 0.54) !important;
}
</style>
